export interface GoBackCurrentState{
    isCurrentChange: boolean
}

export enum GoBackCurrentStateActions{
    INIT_STATE = 'INIT_STATE',
    CHANGING_STATE = 'CHANGING_STATE',
}